import React from 'react'
import Navbar from '../components/Navbar'

const PageNotFound = () => {
  return (
    <div>
      <Navbar />
      <h1 className='flex justify-center mx-auto pt-32 text-xl'>Taka strona nie istnieje</h1>
    </div>
  )
}

export default PageNotFound